
import React from 'react';
import { MapPin, Clock, Phone, Award } from 'lucide-react';

const DemolitionSEOContent = () => {
  const departements = [
    { name: "Aveyron", code: "12", cities: ["Rodez", "Millau", "Villefranche-de-Rouergue"] },
    { name: "Haute-Garonne", code: "31", cities: ["Toulouse", "Muret", "Saint-Gaudens"] },
    { name: "Tarn", code: "81", cities: ["Albi", "Castres", "Mazamet"] },
    { name: "Lot", code: "46", cities: ["Cahors", "Figeac", "Gourdon"] },
    { name: "Cantal", code: "15", cities: ["Aurillac", "Saint-Flour", "Mauriac"] },
    { name: "Lozère", code: "48", cities: ["Mende", "Marvejols", "Florac"] }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto">
        {/* Zone d'intervention */}
        <div className="mb-12">
          <h2 className="text-2xl font-heading font-bold mb-6 text-fabre-gray flex items-center">
            <MapPin className="w-6 h-6 text-fabre-green mr-3" />
            Zones d'Intervention
          </h2>
          <div className="bg-fabre-lightgray rounded-xl p-6">
            <p className="text-gray-700 mb-6">
              Groupe Fabre Environnement intervient sur l'ensemble du territoire français 
              avec une expertise particulière dans les régions Occitanie et Île-de-France.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {departements.map((dept, index) => (
                <div key={index} className="bg-white rounded-lg p-4 shadow-sm">
                  <h4 className="font-semibold text-fabre-gray mb-2">
                    {dept.name} ({dept.code})
                  </h4>
                  <div className="text-sm text-gray-600">
                    {dept.cities.join(", ")}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Pourquoi nous choisir */}
        <div className="mb-12">
          <h2 className="text-2xl font-heading font-bold mb-6 text-fabre-gray flex items-center">
            <Award className="w-6 h-6 text-fabre-green mr-3" />
            Pourquoi Choisir Groupe Fabre ?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gradient-to-br from-fabre-lightgreen to-white rounded-xl p-6">
              <h3 className="text-lg font-bold text-fabre-gray mb-3">
                <Clock className="w-5 h-5 text-fabre-green inline mr-2" />
                Réactivité garantie
              </h3>
              <p className="text-gray-700">
                Intervention rapide sous 48h pour les urgences. 
                Équipes mobilisables 7j/7 selon vos contraintes.
              </p>
            </div>
            <div className="bg-gradient-to-br from-fabre-lightgreen to-white rounded-xl p-6">
              <h3 className="text-lg font-bold text-fabre-gray mb-3">
                <Phone className="w-5 h-5 text-fabre-green inline mr-2" />
                Accompagnement complet
              </h3>
              <p className="text-gray-700">
                De l'étude préalable à l'évacuation des gravats, 
                nous gérons votre projet de A à Z.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DemolitionSEOContent;
